import script from "./Row.vue?vue&type=script&setup=true&lang=js"
export * from "./Row.vue?vue&type=script&setup=true&lang=js"

import "./Row.vue?vue&type=style&index=0&id=bdfdec5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdfdec5a"]])

export default __exports__